import { DataDisplay, formatCurrency, formatDate, Grid, pn, useElementBreakpoints } from "@compass/core";
import { ContributorBulkMergeEmployment, ContributorBulkMergeResource } from "generated/openApi";

export const BasicInfo = (props: {
  employment: ContributorBulkMergeEmployment;
  resource: ContributorBulkMergeResource;
}) => {
  const { breakpointsRef, smallFieldBreakpoints } = useElementBreakpoints();
  const properties = props.resource.employmentProperties || [];

  return (
    <Grid ref={breakpointsRef} container spacing="sm">
      <Grid item xs={smallFieldBreakpoints}>
        <DataDisplay
          label={properties.find((x) => x.propertyName === pn<ContributorBulkMergeEmployment>("partner"))?.displayName}
        >
          {props.employment.partner}
        </DataDisplay>
      </Grid>

      <Grid item xs={smallFieldBreakpoints}>
        <DataDisplay
          label={
            properties.find((x) => x.propertyName === pn<ContributorBulkMergeEmployment>("subPartner"))?.displayName
          }
        >
          {props.employment.subPartner}
        </DataDisplay>
      </Grid>

      <Grid item xs={smallFieldBreakpoints}>
        <DataDisplay
          label={
            properties.find((x) => x.propertyName === pn<ContributorBulkMergeEmployment>("startDate"))?.displayName
          }
        >
          {formatDate(props.employment.startDate)}
        </DataDisplay>
      </Grid>

      <Grid item xs={smallFieldBreakpoints}>
        <DataDisplay
          label={properties.find((x) => x.propertyName === pn<ContributorBulkMergeEmployment>("endDate"))?.displayName}
        >
          {formatDate(props.employment.endDate)}
        </DataDisplay>
      </Grid>

      <Grid item xs={smallFieldBreakpoints}>
        <DataDisplay
          label={
            properties.find((x) => x.propertyName === pn<ContributorBulkMergeEmployment>("hourlySalary"))?.displayName
          }
        >
          {formatCurrency(props.employment.hourlySalary)}
        </DataDisplay>
      </Grid>
    </Grid>
  );
};
